<template>
  <div style="width: 100%;height: 100%;">
    <FrameForm ref="frameForm" component-param="bu_cs_task_detail" :parent-data="parentData" ></FrameForm>

    <!--显示定损故障页面-->
    <div v-if="showTrouble">

      <div style="margin: 10px 0 10px 15px; font-size: 14px;">定损信息:</div>
      <div v-for="(item,index) in troubleList" class="trouble-item">
        <div class="title">
          <span>{{ '定损故障' + (index + 1) }}</span>
        </div>
        <FrameForm :readonly="true" :ref="'item_'+index" component-param="station_identify_trouble"
                   :init-data="item"/>
      </div>
    </div>
    <div v-if="showQuote">
      <div style="margin: 10px 0 10px 15px; font-size: 14px;">客户确认方案:</div>
      <div v-for="(item,index) in repairPlanList" style="margin: 10px 20px 0 30px;" >
        <div class="planClass">
          <span>{{ '定损故障' + (index + 1) }}</span>
        </div>
        <div style="line-height: 32px;width: 95%">故障类型：{{ item.trouble_type_name }}</div>
        <div style="line-height: 32px;width: 95%">故障描述：{{item.trouble_desc}}</div>
        <div style="line-height: 32px;width: 95%;display: flex">故障图片：
        <KfImageViewer :image-list="item.imageFiles"/>
        </div>
        <div style="line-height: 32px;width: 95%">消耗物料清单</div>
        <div v-for="material in item.material_plan_list">
          <div>{{material.material_name}}</div>
          <div style="display: flex">
            <div style="width: 30%">数量：{{material.material_cnt}}</div>
            <div style="width: 30%">单价：{{material.material_price}}</div>
            <div style="width: 30%">总额：{{material.total_price}}</div>
          </div>
          <div>物料成色：
            <el-radio-group v-model="material.material_type" disabled>
              <el-radio label="new_product" size="large">新品</el-radio>
              <el-radio label="good_product" size="large">良品</el-radio>
              <el-radio label="defective_product" size="large">瑕疵品</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div style="width: 100%;display: flex">
          <div style="width: 50%;text-align: left">维修类型：{{item.service_level_name}}</div>
          <div style="width: 20%;text-align: right">{{item.service_level_cost}}</div>
        </div>
        <div style="width: 95%;text-align: center">
          <el-radio-group v-model="item.is_repair" disabled>
            <el-radio :label="true" size="large">维修</el-radio>
            <el-radio :label="false" size="large">不维修</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="margin: 30px 0 10px 15px; font-size: 14px;font-weight: bold;">费用合计</div>
      <div style="margin-left: 30px;margin-top: 10px;display: flex;width: 300px;border-bottom: 1px silver solid;">
        <div style="width: 150px;text-align: left">物料费用：</div>
        <div style="width: 150px;text-align: right">{{ materialTotalPrice }}</div>
      </div>
      <div style="margin-left: 30px;margin-top: 10px;display: flex;width: 300px;border-bottom: 1px silver solid;">
        <div style="width: 150px;text-align: left">维修服务费：</div>
        <div style="width: 150px;text-align: right">{{ servicePrice }}</div>
      </div>
      <div style="margin-left: 30px;margin-top: 10px;display: flex;width: 300px;border-bottom: 1px silver solid;">
        <div style="width: 150px;text-align: left">总计：</div>
        <div style="width: 150px;text-align: right">{{ totalPrice }}</div>
      </div>
      <div style="margin:10px 0 20px 30px;display: flex;width: 300px;border-bottom: 1px silver solid;">
        <div style="width: 150px;text-align: left">应付总价（RMB）：</div>
        <div style="width: 150px;text-align: right">{{ waitPayPrice }}</div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "BuTaskDetail",
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showTrouble:false,
      showQuote:false,
      troubleData:{},
      troubleList:[],
      repairPlanList:[],
      materialTotalPrice:0.0,
      servicePrice:0.0,
      totalPrice:0.0,
      waitPayPrice:0.0
    }
  },

  async created() {
    await this.getShowTrouble();
    await this.getShowQuote();
    await this.getTroubleList();
    await this.getRepairPlanList();
  },


  methods: {
    async getShowTrouble(){
      let params = {
        itemId:this.parentData.item_id
      }
      let data = await this.$http("buCsTaskService.getIdentifyInfo",params);
      if(data !== undefined){
        this.showTrouble = data.showTrouble;
      }

    },

    async getShowQuote(){
      let params = {
        itemId:this.parentData.item_id
      }
      let data = await this.$http("buCsTaskService.getRepairPlanInfo",params);
      if(data !== undefined){
        this.showQuote = data.showQuote;
      }

    },

    async getTroubleList(){
      let params = {
        itemId:this.parentData.item_id,
      }
      this.troubleList = await this.$http("buItemStationService.getIdentifyInfo",params);

    },

    async getRepairPlanList(){
      let params = {
        itemId:this.parentData.item_id,
      }
      let data = await this.$http("buItemStationService.getRepairPlanInfo",params);
      if(data !== undefined){
        this.repairPlanList = data.trouble_plan_list;
        this.materialTotalPrice = data.material_total_price;
        this.servicePrice = data.service_price;
        this.totalPrice = data.total_price;
        this.waitPayPrice = data.wait_pay_price;
      }

    }



  }
}
</script>

<style scoped lang="less">

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}

.planClass {
  background-color: #ddd;
  padding: 5px 0 5px 10px;
  font-weight: bold;
}

</style>